module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-Regular-f7715bb4958cd26f50bcabc6063eaedb.ttf";